import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components/macro";
import Size from "../../../images/unit/wizard/Size.gif";
import population from "../../../images/unit/wizard/type-and-population.gif";
import Location from "../../../images/unit/wizard/Location-round.gif";
import { CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const WizardUnitLoad = ({ onClick, isDemo }) => {
  const [progress, setProgress] = useState(0);
  const classes = useStyles();

  const newProgress = useRef(0);

  useEffect(() => {
    if (isDemo) {
      let interval = setInterval(() => {
        newProgress.current = Math.min(
          newProgress.current + Math.floor(Math.random() * 1) + 0.33,
          100
        );
        setProgress(newProgress.current);
        if (newProgress.current >= 100) {
          clearInterval(interval);
          setTimeout(() => {
            onClick();
          }, 0);
        }
      }, 50);
    } else {
      onClick();
    }
    // Mount-once: kicks off the demo loading animation a single time.
    // Tracking isDemo/onClick would restart the interval on parent re-renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _renderPercentTitle = (progress) => {
    if (progress < 28) {
      return "Checking geographic location";
    } else if (progress < 63) {
      return "Calculating building size";
    } else {
      return "Curating by Building type and population";
    }
  };

  const _renderPercentImage = (progress) => {
    if (progress < 28) {
      return Location;
    } else if (progress < 63) {
      return Size;
    } else {
      return population;
    }
  };

  _renderPercentTitle(progress);
  return (
    <Wrapper>
      <TitleWrapper>
        <Title fontSize={35}>BUILDING YOUR TULU!</Title>
      </TitleWrapper>

      <div style={{ margin: "50px 0" }}>
        <TypographyWrapper>
          <CircularProgress
            className={classes.buttonProgress}
            style={{ width: "20px", height: "20px", marginRight: "15px" }}
          />
          <Text
            style={{ textAlign: "center" }}
            variant="caption"
            component="div"
            color="textSecondary"
          >{`${_renderPercentTitle(progress)}`}</Text>
        </TypographyWrapper>
        <LinearProgress>
          <LinearProgressInside value={progress} />
        </LinearProgress>
      </div>
      {/*<Title style={{ opacity: "0.8" }}*/}
      {/*       fontSize={20}>{"in a few moments you'll get the TULU demo\nEquipped with the best products based on you data!\n\nPlease prepare a relevant picture of your space."}</Title>*/}
      <img
        style={{ height: "50vh" }}
        src={_renderPercentImage(progress)}
        alt={"progress"}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  align-items: center;
  justify-content: center;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

const Title = styled.div`
  padding: 10px 0;
  color: ${({ color = "#4b4b4b" }) => color};
  font-size: ${({ fontSize = 50 }) => fontSize}px;
  white-space: pre-wrap;
  text-align: center;
  font-family: Manrope, serif;
`;
const TitleWrapper = styled.div`
  display: flex;
  position: relative;
  align-items: center;
`;
const TypographyWrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
`;
const LinearProgress = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  width: 30vw;
  height: 15px;
  border-radius: 20px;
  border: 1px solid #707070;
`;

const LinearProgressInside = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  bottom: 0;
  right: calc(30vw * ${({ value }) => 1 - value / 100});
  left: 0;
  border-radius: 20px;
  background-color: #13647b;
`;

const Text = styled.div`
  color: #4b4b4b;
  font-size: 16px;
  white-space: pre-wrap;
  font-family: Manrope, serif;
`;

export { WizardUnitLoad };

const useStyles = makeStyles((theme) => ({
  buttonProgress: {
    color: "#4b4b4b",
  },
}));
